import apiData from "lib/stores/apiData";
import mapData from "lib/stores/mapData";

export default function getProductPoints() {
  const { selectedProduct, productsCountry } = mapData;
  const returnData = [];
  const data = apiData.countries[productsCountry];
  data.imports.forEach(d => {
    const exportingCountry = Object.keys(apiData.countries).find(country => {
      return apiData.countries[country].iso === d.exporter;
    });
    if (exportingCountry && d.product.toLowerCase().replaceAll(' ', '%20') === selectedProduct) {
      returnData.push({
        from: {
          coordinates: [apiData.countries[productsCountry].centroid.cx, apiData.countries[productsCountry].centroid.cy]
        },
        to: {
          coordinates: [apiData.countries[exportingCountry].centroid.cx, apiData.countries[exportingCountry].centroid.cy]
        }
      });
    }
  });
  return returnData;
}
